import { render, staticRenderFns } from "./KT-Proposal.vue?vue&type=template&id=47657744&scoped=true&"
import script from "./KT-Proposal.vue?vue&type=script&lang=js&"
export * from "./KT-Proposal.vue?vue&type=script&lang=js&"
import style0 from "./KT-Proposal.vue?vue&type=style&index=0&id=47657744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47657744",
  null
  
)

export default component.exports